import { render, staticRenderFns } from "./AStaffDetailHisFee.vue?vue&type=template&id=481182f8&scoped=true"
import script from "./AStaffDetailHisFee.vue?vue&type=script&lang=js"
export * from "./AStaffDetailHisFee.vue?vue&type=script&lang=js"
import style0 from "./AStaffDetailHisFee.vue?vue&type=style&index=0&id=481182f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481182f8",
  null
  
)

export default component.exports